<template>
	<div class="test_complete">
		<div class="test_complete_title">
			¡Has completado el examen!
		</div>
		<div v-if="this.program.recognition">
			<div class="test_complete_description" v-if="!this.loading">
				¡Felicitaciones por culminar exitosamente porfavor dale en continuar
				para procesar tu puntaje.
			</div>
			<div class="test_complete_image">
				<img src="@/assets/images/evaluation/complete.svg" />
			</div>
			<div class="test_complete_footer">
				<v-btn
					color="primary"
					class="uppercase"
					@click="nextStep"
					:loading="loading"
				>
					Continuar
				</v-btn>
			</div>
		</div>
		<div v-else>
			<div class="test_complete_description">
				Al presionar el botón continuar, podrás programar tu asesoría con uno de
				nuestros docentes especializados.
			</div>
			<div class="test_complete_image">
				<img src="@/assets/images/evaluation/complete.svg" />
			</div>
			<div class="test_complete_footer">
				<v-btn color="primary" class="uppercase" @click="nextStep">
					Continuar
				</v-btn>
			</div>
		</div>
	</div>
</template>
<script>
import axios from "@/axios-auth";
import { mapGetters, mapMutations } from "vuex";

export default {
	data() {
		return {
			loading: false,
			recognitionData: null,
			user: null,
			obtained: false,
		};
	},
	methods: {
		...mapMutations(["setRecognition"]),
		nextStep() {
			if (!this.program.recognition) {
				this.$emit("nextStep", 2);
				this.$router.push({ path: `/evaluation/schedule` });
			} else {
				this.registerRecognition();
			}
		},
		async registerRecognition() {
			//TODO
			console.log("registrando");
			this.loading = true;
			let obj = {
				applicationId: this.postulation.id,
			};
			await axios
				.post(`users/recognition/`, obj, {
					headers: { Authorization: "Token " + this.user.token },
				})
				.then((response) => {
					this.recognitionData = response.data;
					this.loading = false;
					this.$emit("nextStep", 2);
					this.setRecognition(this.recognitionData);
					this.obtained = true;
					this.$emit("updateValueRecognition", this.obtained);
					console.log(
						"TestRecognition - registerRecognition - recognitionData",
						this.recognitionData
					);
					console.log(
						"TestRecognition - registerRecognition - recognition",
						this.recognition
					);
				})
				.catch((err) => {
					console.error(err);
					this.loading = false;
					this.$emit("nextStep", 2);
				});
		},
	},
	computed: {
		...mapGetters({
			program: "program",
			recognition: "recognition",
			postulation: "postulation",
		}),
	},
	mounted() {
		this.user = this.$store.state.usuario;
	},
};
</script>
